

import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import { DevicesModule } from '~/store/modules/devices';
import DumpPopupMixin from '~/mixins/dumpPopup.mixin';

@Component
export default class OperationModelDumpPopup extends Mixins(PopupMixin, DumpPopupMixin) {
    filePrefix = 'modelDump';

    get rawDumpValue() {
        return DevicesModule.modelDumpValue;
    }

    async getModelDump() {
        try {
            const data = await DevicesModule.currentGateway?.modelDump();
            await DevicesModule.setModelDumpValue(data);
        } catch (error) {
            await DevicesModule.setModelDumpValue('Error while fetching dump');
        }
    }
}
